import { configureStore } from '@reduxjs/toolkit'
import storeReducer from './storeSlice'
import notificationReducer from './notificationSlice'
import settingsReducer from './settingsSlice'

export const store = configureStore({
  reducer: {
    store: storeReducer,
    notifications: notificationReducer,
    settings: settingsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  })
})

export default store 